//to be changed after availing exact live URL and after changes
var socketUATURL = "wss://nstuat.nuvamawealth.com";
// const socketUATURL: string = "wss://vamauat.nuvamawealth.com";
var socketLIVEURL = "wss://ndst.nuvamawealth.com";
//const socketLIVEURL: string = "wss://tx3stream.edelweiss.in";
//const socketLIVEURL: string = "wss://ndst.nuvamawealth.com";
var LivePort = 9663;
var UATPort = 12016;
// const UATPort = 8443;
// Assign object to a variable before exporting as module default  import/no-anonymous-default-export
var socketConfig = {
    socketURL: process.env.NODE_ENV === "production" || process.env.NODE_ENV === "cug"
        ? socketLIVEURL
        : socketLIVEURL,
    port: process.env.NODE_ENV === "production" || process.env.NODE_ENV === "cug"
        ? LivePort
        : LivePort,
};
export default socketConfig;
